<template>
	<div ref="emrColumnManageEdit" class="dialog-container">
		<div class="dialog" style="max-height: 500px; transform: translate(0, -250px);">
			<form @submit.stop="doValidation()">
				<div class="top">
					<p class="txt-crud-title">
						Emr Column Edit
					</p>
				</div>
				<div class="center">
					<table class="tb-crud-horizon">
						<colgroup>
							<col width="17%" />
							<col width="33%" />
							<col width="17%" />
							<col width="33%" />
						</colgroup>
						<tbody>
							<tr>
								<th>
									No
								</th>
								<td colspan="3">
									{{ item.columnNo }}
								</td>
							</tr>
							<tr>
								<th>
									Project
								</th>
								<td  colspan="3">
									<select 
										class="select-crud"
										style="max-width: 100%;"
										v-model="item.projectNo"
										disabled
									>
										<option value="" selected disabled>--- select project ---</option>
										<option v-for="(item, index) in projectList" :key="index" :value="item.projectNo">
											{{ "(V"+item.projectVersion+")" + item.projectStudyTitle }}
										</option>
									</select>
								</td>
							</tr>
							<tr>
								<th>
									Korean Column
								</th>
								<td colspan="3">
									<input
										type="text"
										class="input-crud"
										name="columnKoreanName"
										v-model="item.columnKoreanName"
										v-validate="'required'"
										data-vv-as="Column Korean Name"
										@input="doDuplicateCheck()"
									/>
									<p class="txt-validation" v-if="errors.has('columnKoreanName')">
										* {{ errors.first("columnKoreanName") }}
									</p>
									<p class="txt-validation" v-if="isDuplicate">
										* The column is duplicated.
									</p>
								</td>
							</tr>
							<tr>
								<th>
									English Column
								</th>
								<td colspan="3">
									<input
										type="text"
										class="input-crud"
										name="columnEnglishName"
										v-model="item.columnEnglishName"
										v-validate="'required'"
										data-vv-as="Column English Name"
										@input="doDuplicateCheck()"
									/>
									<p class="txt-validation" v-if="errors.has('columnEnglishName')">
										* {{ errors.first("columnEnglishName") }}
									</p>
									<p class="txt-validation" v-if="isDuplicate">
										* The column is duplicated.
									</p>
								</td>
							</tr>
							<tr>
								<th>Register.</th>
								<td>
									{{ item.firstRegistUserId }}
								</td>
								<th>
									Regist Date.
								</th>
								<td>
									{{ item.firstRegistDate.substring(0, 10) }}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="bottom">
					<button type="button" class="btn-save fright" title="Modify" @click.stop="doValidation()">
						Modify
					</button>
					<button type="button" class="btn-cancel fright" title="Cancel" @click="doCancel()">
						Cancel
					</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import EventBus from "@/script/EventBus.js";

export default {
	name: "AuthEdit",
	created() {
		this.logger.debug(this, "created()");
		this.item.projectNo = this.projectNo
		this.selectEmrProjectList();
		this.doSelect();
	},
	props: {
		columnNo: {
			type: String,
			required: true
		},
		projectNo: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			item: {},
			projectList: [],
			isDuplicate: false
		};
	},
	methods: {
		selectEmrProjectList(){
			this.logger.debug(this, "selectEmrProjectList()");
			axios
				.post(this.config.contextRoot + "/emr/selectEmrProjectList.do", this.item)
				.then((response) => {
					console.log(response);
					this.projectList = response.data.projectList;
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		doSelect() {
			this.logger.debug(this, "doSelect()");
			axios
				.post(this.config.contextRoot + "/emr/selectColumn.do", {columnNo: this.columnNo})
				.then((response) => {
					console.log(response);
					this.item = response.data.item;
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		doDuplicateCheck() {
			this.logger.debug(this, "doDuplicateCheck()");
			if(this.item.columnKoreanName != "" && this.item.columnEnglishName != "")
			{
				axios
				.post(this.config.contextRoot + "/emr/duplicateColumnCheck.do", this.item)
				.then((response) => {
					console.log(response);
					this.isDuplicate = response.data.isDuplicate;
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
			}
		},
		doValidation() {
			this.logger.debug(this, "doValidation()");
			if(this.item.projectNo == ''){
				this.$alert("select project" ,"Warn","warning");
				return false;
			}
			this.$validator
				.validateAll()
				.then((result) => {
					this.logger.debug(this, "doValidationResult:" + result);
					if (result && !this.isDuplicate)
					{
						this.$confirm("Do you want to modify the emr column?", "Question", "question").then(() => {
							EventBus.$emit("setting-loading", true);
							this.doUpdate();
						});
					}
				})
				.catch(() => {
					this.logger.debug(this, "-->" + this.errors.all());
					alert(this.errors.all());
					return false;
				});
		},
		doUpdate() {
			this.logger.debug(this, "doUpdate()");
			axios
				.post(this.config.contextRoot + "/emr/updateColumn.do", this.item)
				.then((response) => {
					if (response.status == 200)
					{
						console.log(response);
						location.reload();
					}
					else
					{
						alert(response);
						console.log(response);
					}
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		doCancel() {
			this.logger.debug(this, "doCancel()");
			this.$confirm("Do you want to cancel the emr editing?", "Question", "question").then(() => {
				this.doClose();
			});
		},
		doClose() {
			this.logger.debug(this, "doClose()");
			this.$refs.emrColumnManageEdit.style.animation = "fadeOut 0.4s ease-in-out both";
			this.$refs.emrColumnManageEdit.children[0].style.animation = "fadeOutDrop 0.4s ease-in-out both";
			setTimeout(function() {
				EventBus.$emit("setting-cancel", "isEmrColumnManageEdit");
			}.bind(this), 410);
		}
	}
};
</script>

<style scoped>
.btn-cancel {
	margin-right: 10px;
}
</style>